// The value of rootFontsize should be the same as the one in the global styles
// If you did not change anything in html fontSize, it should be 16, if 62.5% then 10
export const pxToRem = (value: number, rootFontsize = 16) => `${value / rootFontsize}rem`;

export const defaultFontFamily = /* #__PURE__ */ 'Open Sauce One, sans-serif';
